module.exports = __webpack_public_path__ + "img/Icon-Avatar.cb5d9118.svg";